import axios from "axios";
import { getActiveAccountId } from "../activeAccount";

export function getAPI() {
  const accountId = getActiveAccountId();
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      "Content-Type": "application/json",
      ...(accountId && { "X-Account-Id": accountId }),
    },
    withCredentials: true,
  });
}
